export class EdaDatePickerConfig{
  public dateRange : Array<Date>;
  public range : string;
  public filter : string;
}